import React, { useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Input } from 'components';
import { useAction, useSelect } from 'hooks';

const SelectProvince = memo(({ prefixName, region_id, value, helperMessage, onChange }) => {
  
  const getList = useAction('province.getList', { prefix: prefixName })
  const list = useSelect('province.list', { prefix: prefixName })
  const listing = useSelect('loading.isLoading', { type: `${prefixName || ''}province.getList` })

  const options = Object.values(list).map(item => {
    return {
      label: get(item, 'attributes.name'),
      value: get(item, 'id')
    }
  })

  useEffect(() => {
    if(region_id)
      getList(prefixName, { region_id });
  // eslint-disable-next-line
  }, [region_id])

  return (
    <Input
      type="select"
      name={prefixName ? `${prefixName}province_id` : `province_id`} 
      label="Province"
      isLoading={listing}
      options={options}
      value={value}
      helperMessage={helperMessage}
      onChange={onChange}
    />
  )
})

SelectProvince.defaultProps = {
  helperMessage: undefined,
  prefixName: null
}

SelectProvince.propTypes = {
  prefixName: PropTypes.string,
  region_id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  helperMessage: PropTypes.instanceOf(Function),
  onChange: PropTypes.instanceOf(Function).isRequired,
}

export default SelectProvince